import React from 'react'

function OpeningList({ Data }) {
  return (
    <div className="card h-100 mb-0">
      <div className="card-body">
        <h6 className="dash-sub-head">Job Openings List</h6>
        <div className="table-responsive mt-2 analytics-div table-overflow">
          <table className="table table-striped">
            <thead>
              <tr>
                <th style={{ width: '20%', minWidth: '200px' }}>Summary</th>
                <th style={{ width: '10%', minWidth: '150px' }}>Positions</th>
                <th style={{ width: '15%', minWidth: '150px' }}>Start Date</th>
                <th style={{ width: '15%', minWidth: '150px' }}>End Date</th>
                <th style={{ width: '10%', minWidth: '100px' }}>Priority</th>
                <th style={{ width: '10%', minWidth: '100px' }}>Experience</th>
                <th style={{ width: '10%', minWidth: '150px' }}>Created By</th>
                <th style={{ width: '10%', minWidth: '100px' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {Data.map((item, index) => (
                <tr key={index}>
                  <td>{item.summary}</td>
                  <td>{item.no_of_position}</td>
                  <td>{new Date(item.start_date).toLocaleDateString()}</td>
                  <td>{new Date(item.end_date).toLocaleDateString()}</td>
                  <td>{item.priority}</td>
                  <td>{item.experiance} years</td>
                  <td>{item.created_by}</td>
                  <td>
                    <div className={`status-bar ${item.status === 'Closed' ? 'status-red' : 'status-green'}`}>
                      {item.status}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default OpeningList